import React from 'react';
import { rem } from 'polished';
import styled from 'styled-components';

import { circle, flexCenter } from 'helpers/styles/mixins';

interface WrapperProps {
  topOffset?: number;
  rightOffset?: number;
  isBold?: boolean;
}

const Wrapper = styled.div<WrapperProps>`
  ${circle(rem(20))};
  position: absolute;
  top: ${({ topOffset }) => (topOffset ? rem(topOffset) : 0)};
  right: ${({ rightOffset }) => (rightOffset ? rem(rightOffset) : 0)};
  overflow: hidden;
  font-size: ${({ theme }) => theme.fontSizes.dbSmallSm};
  color: ${({ theme }) => theme.colors.badgeErrorText};
  border: ${rem(3)} solid ${({ theme }) => theme.colors.badgeErrorText};
  transform: translate(50%, -50%);
`;

const Content = styled.div`
  ${flexCenter()};
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.badgeErrorBg};
`;

interface Props extends Omit<WrapperProps, 'isBold'> {
  children: React.ReactChild;
}

const NotificationCounter = ({ children, topOffset, rightOffset }: Props) => (
  <Wrapper data-test="item-notification" topOffset={topOffset} rightOffset={rightOffset}>
    <Content>{children}</Content>
  </Wrapper>
);

export default NotificationCounter;
